
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
    props: {
        name: String,
        img: String,
        route: String,
    },
});
